module.exports = __webpack_public_path__ + "e88bfbcbfb56f9ebfc6f5d4fa772ec19.svg";